import React, { useState } from "react";
import Logo from "./acm_logo.png";
import { Eye, EyeOff, UserRound } from "lucide-react";
// import axios from 'axios';
import toast, { Toaster } from 'react-hot-toast';
import backgroundImage from "./background.png";
import { useNavigate } from "react-router-dom";
import Trainer from "../../imgs/Trainer.jpg";
import Trainee from "../../imgs/Trainee.jpg";
import { useFormik, FormikHelpers } from 'formik';
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import HeroImg from "../../Shared components/HeroImg";
// Type definitions for form values
interface LoginFormValues {

    email: string;
    password: string;
    role: string;
}

export default function ChooseRole() {
    const [viewPassword, setViewPassword] = useState(false);
    const [rememberMe, setRememberMe] = useState(false);
    const navigate = useNavigate();

    // Validation schema


    const [isLoading, setLoading] = useState(false);


    const roles: string[] = ["Trainer", "Trainee"]
    return (
        <>
            <Toaster />
            <div className="flex flex-row  md:h-screen w-full mb-10 md:my-0">
                <HeroImg />
                <div className="flex flex-col items-center justify-start w-full mt-10">
                <div >
                            <h2 className="text-[32px] leading-[67.58px] font-[500] text-neutral-900 flex flex-col md:flex-row-reverse items-end">  مرحباً بكم في <div className='mr-2'>Otlob Coach</div></h2>
                        </div>
                    <div>
                        <p className="text-[16px] leading-[24px] font-[400] text-neutral-900">هل لديك حساب بالفعل؟<span className="underline mr-1"> <a href="login">تسجيل الدخول</a></span></p>
                    </div>
                    <div className="mt-[8px] flex flex-col items-center ">
                        <p className="text-[32px] leading-[67.58px] font-[700] text-neutral-900">من انت؟</p>
                        <div className="grid md:grid-cols-2 gap-8 mt-8">
                            <a href="userimage/trainee">
                                <div className="w-[162px] h-[171px] rounded-xl pt-[10px] pb-[10px] pl-[30px] pr-[30px] flex flex-col items-center justify-center border-[1px] border-neutral-300 cursor-pointer hover:border-primary-500 hover:bg-primary-100 transition-all duration-200 group">
                                    <img src={Trainer} alt="" className="w-[102px] h-[100px] rounded-[30px]" />
                                    <p className="text-[24px] leading-[50.69px] font-[700] text-neutral-900 group-hover:text-white">متدرب</p>
                                </div>
                            </a>
                            <a href="userimage/trainer">
                                <div className="w-[162px] h-[171px] rounded-xl pt-[10px] pb-[10px] pl-[30px] pr-[30px] flex flex-col items-center justify-center border-[1px] border-neutral-300 cursor-pointer hover:border-primary-500 hover:bg-primary-100 transition-all duration-200 group">
                                    <img src={Trainee} alt="" className="w-[102px] h-[100px] rounded-[30px]" />
                                    <p className="text-[24px] leading-[50.69px] font-[700] text-neutral-900 group-hover:text-white">مدرب</p>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}